export default __webpack_public_path__ + "static/media/7.de856249.jpg";